import type { InputTableColumn } from '@/components/custom/erp/input-table-v2';
import { CellFieldV2, SearchField } from '@/components/custom/erp';
import { phiSearchColumns, QUERY_KEYS } from '@/constants';
import { ChiPhi } from '@/types/schemas';

export const getFeeTableColumns = (
  onCellValueChange: (rowUuid: string, field: string, newValue: MuaHangRecord) => void
): InputTableColumn[] => [
  {
    field: 'ma_cp',
    headerName: 'Mã chi phí',
    width: 120,
    renderCell: params => (
      <SearchField<ChiPhi>
        type='text'
        searchEndpoint={`/${QUERY_KEYS.CHI_PHI}/`}
        searchColumns={phiSearchColumns}
        columnDisplay='ma_cp'
        dialogTitle='Danh mục chi phí'
        value={params.row.ma_cp_data?.ma_cp || ''}
        onRowSelection={(row: MuaHangRecord) => onCellValueChange(params.row.uuid, 'ma_cp_data', row)}
      />
    )
  },
  {
    field: 'ten_cp',
    headerName: 'Tên chi phí',
    width: 120,
    renderCell: params => <CellFieldV2 name='ten_cp' type='text' value={params.row.ma_cp_data?.ten_cp} disabled />
  },
  {
    field: 'ten_cp_nt',
    headerName: 'Tiền VNĐ',
    width: 120,
    renderCell: params => (
      <CellFieldV2
        name='ten_cp_nt'
        type='number'
        value={params.row.ten_cp_nt}
        commitOnBlur
        onValueChange={value => onCellValueChange(params.row.uuid, 'ten_cp_nt', value)}
      />
    )
  },
  {
    field: 'line_vt',
    headerName: 'Dòng chi tiết',
    width: 150,
    renderCell: params => <CellFieldV2 name='line_vt' type='text' value={params.row.ma_cp_data?.line_vt} disabled />
  }
];
